import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';

import { cityDetailLoad } from "store/api/geo_city";
import { DataLoadComponent } from 'components/common';


class CityValue extends DataLoadComponent {
    apiDetailLoad = cityDetailLoad;

    render() {
        const { id, mode } = this.props;
        const { detail, loadStatus } = this.state;
        const value = (detail && detail.name_en) || id;
        const asLink = mode === 'link' && detail && detail.country;

        return (
            <Spin spinning={loadStatus.isLoading}>
                {asLink ?
                    <Link to={`/country/${detail.country}`}>{value}</Link>
                    :
                    <span>{value}</span>
                }
            </Spin>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth_token: state.auth.token,
    };
}

export default connect(mapStateToProps)(CityValue);
